export const GET_THEORIES = '[THEORIES] GET_THEORIES'
export const GET_THEORY = '[THEORIES] GET_THEORY'
export const GET_GRADES = '[THEORIES] GET_GRADES'
export const GET_SUBJECT = '[THEORIES] GET_SUBJECT'
export const GET_TOPIC = '[THEORIES] GET_TOPIC'
export const GET_SUBTOPIC = '[THEORIES] GET_SUBTOPIC'
export const GET_LANGUAGES = '[THEORIES] GET_LANGUAGES'
export const SET_METADATATHEORY = '[THEORIES] SET_METADATATHEORY'
